<template>
  <div class="plan-select-for-free-pane">
    <signup-header-section :steps="3" :pageTitle="$tc('SignupPage.Steps.Step3')" />

    <h3 class="plan-select-for-free-pane__title">{{ $tc('SignupPage.SelectPlanPage.title') }}</h3>

    <comparison-plan-section
      class="plan-select-for-free-pane__comparison-plan"
      :section-title="$tc('SignupPage.SelectPlanPage.comparison.comparisonDescriptionForFree')"
    />

    <choose-plan-section
      class="plan-select-for-free-pane__choose-plan"
      :selectedPlanGroupId="selectedPlanGroupId"
      :planList="contractPaidPlans"
      :procedureScreen="procedureScreen"
      @handlerPlanSelect="handlerPlanSelect"
    />

    <action-buttons-section
      class="plan-select-for-free-pane__action-buttons"
      scrollTargetSelector=".plan-select-for-free-pane"
      :visible="true"
    >
      <atom-input-button
        class="plan-select-for-free-pane__action-buttons__paid"
        :linkText="$tc('SignupPage.SelectPlanPage.submit.changeMemberShip')"
        :isDisabled="selectedPlanGroupId === ''"
        @push="handlerPaidChangeClick"
      />
      <atom-input-button
        class="plan-select-for-free-pane__action-buttons__free"
        :linkText="$tc('SignupPage.SelectPlanPage.submit.stayOnFreePlan')"
        :isDisabled="false"
        colorType="tertiary"
        @push="handlerSubmit"
      />
    </action-buttons-section>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, Ref } from '@vue/composition-api'
import SignupHeaderSection from '@/components/SignupPage/common/SignupHeaderSection.vue'
import ComparisonPlanSection from '@/components/SignupPage/common/ComparisonPlanSection.vue'
import ChoosePlanSection from '@/components/SignupPage/PlanSelectForFreePane/ChoosePlanSection.vue'
import ActionButtonsSection from '@/components/common/form/ActionButtonsSection.vue'
import AtomInputButton from '@/components/atoms/input/AtomInputButton.vue'
import { ProcedureScreenType } from '@/store/stores/collectionModule/documents/GeneralTypes'
import ContractPlanDocument, {
  PaidPlanGroupType,
} from '@/store/stores/collectionModule/documents/plan/ContractPlanDocument'
import Const from '@/util/Const'
import StoreUtil from '@/store/StoreUtil'

/**
 * 新規会員登録:プラン選択画面ペインのコンポーネント (無料会員向け)
 */
export default defineComponent({
  name: 'PlanSelectForFreePane',
  components: {
    SignupHeaderSection,
    ComparisonPlanSection,
    ChoosePlanSection,
    ActionButtonsSection,
    AtomInputButton,
  },
  props: {
    /**
     * 選択中のプラングループID（プラン）
     */
    selectedPlanGroupId: {
      type: String as PropType<PaidPlanGroupType>,
      required: true,
    },
    /**
     * どの手続き画面か
     */
    procedureScreen: {
      type: String as PropType<ProcedureScreenType>,
      default: null,
    },
  },
  setup(props, context) {
    const signupPageStore = StoreUtil.useStore('SignupPageStore')
    const { contractPaidPlans } = signupPageStore
    /**
     * プラン選択
     * @param planGroupId {PaidPlanGroupType}
     */
    const handlerPlanSelect = (planGroupId: PaidPlanGroupType) => {
      context.emit('handlerPlanSelect', planGroupId)
    }

    return {
      Const,
      contractPaidPlans: contractPaidPlans as Ref<Array<ContractPlanDocument>>,
      handlerPlanSelect,
    }
  },
  methods: {
    /**
     * プラン選択切り替え処理 有料向けの画面に切り替わる
     */
    handlerPaidChangeClick() {
      this.$emit('handlerPaidChangeClick', this.Const.MEMBER_TYPE.PAID)
    },
    /**
     * プラン登録遷移処理
     */
    handlerSubmit() {
      this.$emit('handlerSubmit')
    },
  },
})
</script>

<style lang="scss" scoped>
.plan-select-for-free-pane {
  width: 100%;
  color: $gray75;
  background: $gray1;

  &__title {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 72px;
    margin-top: 10px;
    @include fontSetTextMedium(17);

    text-align: center;
    letter-spacing: 0.04em;
    font-feature-settings: 'palt' on;
    border-bottom: 1px solid $black10;
  }

  &__choose-plan {
    padding-bottom: 240px;
  }

  &__comparison-plan {
    border-bottom: 1px solid $black10;
  }

  &__action-buttons {
    bottom: 0;

    @media screen and (max-width: $responsiveTabletWidth) {
      flex-direction: row-reverse;
    }
  }
}
</style>
